import React from 'react';
import { Box, DialogTitleProps, styled, DialogTitle } from '@mui/material';
import StripePattern from '../StripePattern';

export interface DialogHeaderProps {
	title: string;
	variant?: 'danger' | 'success' | 'info';
}
const DialogHeader = (props: DialogHeaderProps) => {
	const { title, variant = 'info', ...rest } = props;
	return (
		<DialogTitle
			{...rest}
			sx={{
				backgroundColor: (theme) => {
					switch (variant) {
						case 'danger':
							return theme.palette.error.main;
						case 'success':
							return theme.palette.success.main;
						case 'info':
							return theme.palette.primary.main;
						default:
							return theme.palette.primary.main;
					}
				},
				position: 'relative',
				flexDirection: 'row',
				justifyContent: 'flex-start',
			}}
		>
			<StripePattern animationSpeed="slow" color="dark" opacity={0.2} />
			<Box
				sx={{
					backgroundColor: (theme) => {
						switch (variant) {
							case 'danger':
								return theme.palette.error.main;
							case 'success':
								return theme.palette.success.main;
							case 'info':
								return theme.palette.primary.main;
							default:
								return theme.palette.primary.main;
						}
					},
					color: (theme) => theme.palette.common.white,
				}}
			>
				{title}
			</Box>
		</DialogTitle>
	);
};

export default DialogHeader;
